import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
var notImplement = function () {
    throw new Error('RouterContext error: actions not implemented, you must use RouterContext.Provider component');
};
export var RouterContext = createContext({
    block: notImplement,
    unblock: notImplement,
    isBlocked: notImplement,
    goTo: notImplement,
    goBack: notImplement,
    replace: notImplement,
    resolvePath: notImplement,
    resolveAbsolutePath: notImplement,
    resolveRoute: notImplement,
    isActive: notImplement,
    isAllow: notImplement,
    match: notImplement,
    getParams: notImplement,
    getQuery: notImplement,
    getName: notImplement,
    getResourceName: notImplement
});
export var useRouterContext = function () { return useContext(RouterContext); };
export var NavigationRouterProvider = function (_a) {
    var children = _a.children, router = _a.router;
    var routerRef = useRef(router);
    if (!routerRef.current.isActive()) {
        routerRef.current.run(window.location.href);
    }
    // TODO: remove to useRouterMatch
    var setCurrentMatchResult = useState(routerRef.current.getCurrentMatch())[1];
    useEffect(function () {
        var subscription = routerRef.current.asObservable().subscribe(function (result) {
            setCurrentMatchResult(result);
        });
        return function () {
            subscription.unsubscribe();
            routerRef.current.terminate();
        };
    }, []);
    return (React.createElement(RouterContext.Provider, { value: routerRef.current.getActions() }, children));
};
//# sourceMappingURL=RouterContext.js.map